module.exports = __webpack_public_path__ + "static/img/synthe1.bb759db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/synthe1.png
// module id = PmW2
// module chunks = 2